import { useNavigate, useParams } from 'react-router-dom';
import { CollectionCard, type Tab } from '../../InfoPageCards';
import { useOverlayPageProps } from '../OverlayPageContext';
import { OverlayTabLayout } from '../OverlayTabLayout';
import { ArchivedPresentations } from './ArchivedPresentations';
import { PresentationsTable } from './PresentationsTable';

const presentationsTabs: Tab<'presentations' | 'archive'>[] = [
  { id: 'presentations', label: 'Presentations' },
  { id: 'archive', label: 'Archived' },
];

export const PresentationsTab = () => {
  const { innerTabId } = useParams<{
    innerTabId?: 'archive';
  }>();

  const tab = innerTabId || 'presentations';
  const navigate = useNavigate();
  const { rootPath } = useOverlayPageProps();

  return (
    <OverlayTabLayout>
      <div className="pb-10">
        <CollectionCard
          currentTabId={tab}
          setTab={(tabId) => {
            if (tabId === 'presentations') {
              navigate(`${rootPath}/presentations`);
            }
            if (tabId === 'archive') {
              navigate(`${rootPath}/presentations/archive`);
            }
          }}
          tabs={presentationsTabs}
          withSearch
          inputPlaceholder="Search for presentation name"
        >
          <>
            {tab === 'presentations' && <PresentationsTable />}
            {tab === 'archive' && <ArchivedPresentations />}
          </>
        </CollectionCard>
      </div>
    </OverlayTabLayout>
  );
};
